<template>
  <div class="map-container">
    <div class="map-here" id="mapHere"></div>

    <div v-bind:class="{ 'untracked-drivers': true, show: hasAvailableDrivers }">
      <div class="title">DRIVERS WITH AVAILABILITY</div>
      <div class="driver" v-for="(driver, index) in drivers.sector" v-if="driver.shiftStart !== null && driver.shiftEnd !== null">
        <div class="header">
          <div class="photo" v-bind:style="{ 'background-image': 'url(\'' + driver.photo + '\')'}"></div>
          <div class="name"><a :href="'/#/provider/' + driver.driverId" target="_blank">{{ driver.name }}</a></div>
          <div class="email"><a :href="'mailto:' + driver.email">{{ driver.email }}</a></div>
          <div class="email"><a href="javscript:;" @click="callDriver(driver)">{{ driver.phone }}</a></div>
        </div>

        <div class="vehicle">
          <div class="photo" v-bind:style="{ 'background-image': 'url(\'' + driver.vehicle.photoUrl + '\')'}"></div>
          <div class="name">{{ driver.vehicle.manufacturer }} {{ driver.vehicle.model }}</div>
          <div class="plate-number">{{ driver.vehicle.licensePlate }}</div>
        </div>

        <div class="shift-info" v-if="driver.shiftStart !== null && driver.shiftEnd !== null">
          <i class="fa fa-check-circle"></i>
          <span>Available from</span>
          <span class="shift-value">{{ driver.shiftStart.format('hh:mmA') }}</span>
          <span>to</span>
          <span class="shift-value">{{ driver.shiftEnd.format('hh:mmA') }}</span>
        </div>

        <div class="rsvp-info" v-if="driver.rsvpId !== null">
          <i class="fa fa-car"></i>
          <span>Reservation</span>
          <a :href="'/#/reservation/' + driver.rsvpId" >{{ driver.rsvpId }}</a>
          <span>set to clear at</span><br/>
          <span class="highlight">{{ driver.dropoffTime.format('MM/DD hh:mmA')}}.</span>
        </div>

        <div class="row controls" v-if="rsvp !== null">
          <div class="small-6 columns padding-R">
            <a class="button cta xsmall block" href="javascript:;" @click="sendToDriver(driver)">SEND TO {{ driver.firstName }}</a>
          </div>
          <div class="small-6 columns padding-L">
            <a class="button cta xsmall block warning" href="javascript:;" @click="assignToDriver(driver)">ASSIGN TO {{ driver.firstName }}</a>
          </div>
        </div>
        <div class="row controls" v-if="rsvp === null">
          <div class="small-12 columns">
            <a class="button cta xsmall block" href="javascript:;" @click="createShift(driver)">CREATE A SHIFT FOR {{ driver.firstName }}</a>
          </div>
        </div>
        <i class="fa fa-home is-home" v-show="driver.isHomeBase"></i>
      </div>
    </div>

    <div v-bind:class="{ 'no-drivers': true, show: drivers.sector.length <= 0 && noDrivers }">
      <i class="far fa-frown fa-2x"></i>
      <div class="message">
        <span>Sorry but we can't find any drivers</span>
        <span v-if="rsvp !== null">
          <span>to cover Reservation</span>
          <a :href="'/#/reservation/' + rsvp.ID" target="_blank">{{ rsvp.ID }}</a>
        </span>
        <span v-if="coverageGap !== null">
          <span>to cover the</span>
          <span class="highlight">{{ coverageGap.start.format('MMM DD hh:mmA') }}</span>
          <span>to</span>
          <span class="highlight">{{ coverageGap.end.format('MMM DD hh:mmA') }}</span>
          <span>shift.</span>
        </span>
      </div>
    </div>

    <div v-bind:class="{ 'submission-modal': true, show: modal.show }">
      <div class="modal-container">
        <div class="modal-content">
          <div class="loader" v-show="modal.loading">
            <i class="fa fa-spinner fa-spin fa-lg"></i>
            <div class="message">{{ modal.loadingMessage }}</div>
          </div>
          <div class="loader" v-show="!modal.loading">
            <i class="fa fa-check-circle fa-lg success-icon" v-show="modal.success"></i>
            <i class="fas fa-exclamation-triangle fa-lg error-icon" v-show="!modal.success"></i>
            <div class="message">{{ modal.doneMessage }}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 1px; height: 0; overflow: hidden;">
      <driver-modal id="HCar" ref="HCar" key="car"></driver-modal>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import driverModal from './DriverModal'
import mapSettings from '@/values/map-settings'
import mapPins from '@/values/map-pin'

export default {
  name: 'coverage-map',
  data () {
    return {
      mapOptions: mapSettings,
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      map: {
        labelBackground: {
          url: '',
          anchor: {
            x: 135,
            y: 20
          },
          scaledSize: {
            width: 270,
            height: 40
          }
        },
        poiPin: {
          url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/poi.png',
          anchor: {
            x: 15,
            y: 15
          },
          scaledSize: {
            width: 30,
            height: 30
          }
        }
      },
      path: {
        base: [],
        animated: [],
        animationID: null
      },
      drivers: {
        sector: [],
        nearby: []
      },
      noDrivers: false,
      infoWindows: {
        pickup: false,
        dropoff: false
      },
      rsvpInfo: {
        pickupTime: null,
        dropoffTime: null,
        distanceInMiles: null
      },
      stopsInfo: [],
      modal: {
        show: false,
        loading: false,
        loadingMessage: '',
        success: false,
        doneMessage: ''
      },
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      isRsvp: false
    }
  },
  components: { driverModal },
  computed: {
    rsvp () { return this.$store.state.coverage.map.rsvp },
    showPolygons () { return this.$store.state.coverage.map.showPolygons },
    sectorItems () {
      let result = []
      let sectors = this.$store.state.coverage.sectors.items
      for (let i = 0; i < sectors.length; i++) {
        result.push(sectors[i
          ])
      }
      return result
    },
    hasUntrackedDrivers () {
      let self = this
      for (let i = 0; i < self.drivers.sector.length; i++) {
        let driver = self.drivers.sector[i]
        if (driver.location === null) {
          return true
        }
      }

      return false;
    },
    hasAvailableDrivers () {
      let self = this
      for (let i = 0; i < self.drivers.sector.length; i++) {
        let driver = self.drivers.sector[i]
        if (driver.shiftStart !== null && driver.shiftEnd !== null) {
          return true
        }
      }

      return false;
    },
    coverageGap () { return this.$store.state.coverage.map.gap },
    kmlInMap () { return this.$store.state.coverage.map.kml },
    kmlsInMap () { return this.$store.state.coverage.map.kmls },
    _triggerWatch () { return this.$store.state.coverage.trigger.watch }
  },
  methods: {
    createShift (driver) {
      this.$store.commit('coverage/setCoverageShiftFormDriver', driver)
      this.$store.commit('coverage/setCoverageShiftFormGap', this.coverageGap)
      this.$store.commit('coverage/setCoverageShiftFormSector', this.$store.state.coverage.map.sector)
      this.$store.commit('coverage/setCoverageShiftFormShow', true)
    },
    sendToDriver (driver) {
      let self = this
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        }
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        }

      }

      let url = ''
      if (!self.rsvp.isPackage) {
        url = '/admin/rsvp/' + self.rsvp.ID + '/send'
      } else {
        url = '/admin/package/' + self.rsvp.package.id + '/send'
      }

      self.$sdk.post(url, {
        token: self.$store.state.session.sessionToken,
        provId: driver.driverId
      }, r => {
        if (r.error) {
          self.modal.loading = false
          self.modal.success = false
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.'
          if (r.error.message) {
            self.modal.doneMessage = r.error.message
          }
        } else {
          self.modal.loading = false
          self.modal.success = true
          let message = ''
          if (!self.rsvp.isPackage) {
            message = 'Sent Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.'
          } else {
            message = 'Sent Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.'
          }
          self.modal.doneMessage = message
        }
        setTimeout(() => {
          self.modal.show = false
        }, 1000)
      })
    },
    assignToDriver (driver) {
      let self = this
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        }
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        }
      }

      let request = null
      if (!self.rsvp.isPackage) {
        request = {
          token: self.$store.state.session.sessionToken,
          rsvpId: self.rsvp.ID
        }
      } else {
        request = {
          token: self.$store.state.session.sessionToken,
          packageId: self.rsvp.package.id
        }
      }

      self.$sdk.post('/provider/' + driver.driverId + '/assign', request, r => {
        if (r.error) {
          self.modal.loading = false
          self.modal.success = false
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.'
          if (r.error.message) {
            self.modal.doneMessage = r.error.message
          }
        } else {
          self.modal.loading = false
          self.modal.success = true
          let message = ''
          if (!self.rsvp.isPackage) {
            message = 'Assigned Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.'
          } else {
            message = 'Assigned Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.'
          }
          self.modal.doneMessage = message
          self.$store.commit('coverage/setCoverageSectorsRefresh', true)

          self.$store.commit('coverage/setCoverageMapShowPolygons', true)
          self.$store.commit('coverage/setCoverageMapRsvp', null)
        }
        setTimeout(() => {
          self.modal.show = false
        }, 1000)
      })
    },
    getCenter (sector) {
      if (sector.centerPointLat !== null && sector.centerPointLng !== null) {
        return {
          lat: sector.centerPointLat,
          lng: sector.centerPointLng
        }
      }
      let points = sector.polygon
      let bounds = new google.maps.LatLngBounds() // eslint-disable-line no-undef

      for (let i = 0; i < points.length; i++) {
        let point = points[i]
        bounds.extend(
          new google.maps.LatLng( // eslint-disable-line no-undef
            point.lat,
            point.lng
          )
        )
      }

      let result = bounds.getCenter()
      return result
    },
    centerSector (sector, index) {
      let self = this
      self.$store.commit('coverage/resetCoverageSectorPolygonOption')
      self.$store.commit('coverage/setCoverageSectorPolygonOption', {
        id: sector.ID,
        polygonOptions: {
          zIndex: 2,
          strokeWeight: 5,
          fillOpacity: 0.75
        }
      })
      self.setBounds(sector.polygon)

      if (!self.sectorItems[index].showPanel) {
        self.$store.commit('coverage/setCoverageSectorsPanelShow', index)
        self.$store.commit('coverage/setCoverageSectorScrollElement', sector.identifier)
      }
    },
    setBounds (points) {
      let self = this

      let bounds = new google.maps.LatLngBounds() // eslint-disable-line no-undef

      for (let i = 0; i < points.length; i++) {
        let point = points[i]
        bounds.extend(
          new google.maps.LatLng( // eslint-disable-line no-undef
            point.lat,
            point.lng
          )
        )
      }
      self.$refs.CoverageMap.$mapObject.fitBounds(bounds)
    },
    getRoute (request, callback) {
      let direction = new google.maps.DirectionsService() // eslint-disable-line no-undef
      direction.route(request, (response, status) => {
        if (status !== google.maps.DirectionsStatus.OK) { // eslint-disable-line no-undef
          return
        }
        callback(response)
      })
    },
    resetCenter () {
      let self = this

      let points = []
      for (let i = 0; i < self.sectorItems.length; i++) {
        if (self.sectorItems[i].polygon === null) {
          continue
        }
        points = points.concat(self.sectorItems[i].polygon)
      }

      if (points.length === 0) {
        self.$refs.CoverageMap.$mapObject.panTo({ lat: 33.942791, lng: -118.410042 })
        return
      }

      self.setBounds(points)
    },
    findDriverIndexInList (id, list) {
      let result = null
      for (let i = 0; i < list.length; i++) {
        if (id === list[i].driverId) {
          return i
        }
      }
      return result
    },
    findDrivers () {
      let self = this

      let pickupTime = null
      if (self.rsvp !== null) {
        if (!self.rsvp.isPackage) {
          pickupTime = moment(self.rsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss Z')
        } else {
          pickupTime = moment(self.rsvp.package.localPickupTime, 'YYYY-MM-DD HH:mm:ss Z')
        }
      }
      let sector = self.$store.state.coverage.map.sector
      let gap = self.$store.state.coverage.map.gap

      let drivers = []
      self.drivers.sector = []
      self.noDrivers = false
      // home base drivers
      for (let i = 0; i < sector.homebaseDrivers.length; i++) {
        let driver = sector.homebaseDrivers[i]
        if (driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue
        }
        drivers.push({
          driverId: driver.driverId,
          name: driver.firstName + ' ' + driver.lastName,
          phone: driver.phoneNumber,
          email: driver.email,
          isHomeBase: true,
          packageId: null,
          rsvpId: null,
          pickupTime: null,
          shiftStart: null,
          shiftEnd: null,
          location: null,
          photo: null,
          services: driver.services
        })
      }
      // working drivers
      for (let i = 0; i < sector.workDrivers.length; i++) {
        let driver = sector.workDrivers[i]
        if (driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue
        }
        let index = self.findDriverIndexInList(driver.driverId, drivers)
        if (index === null) {
          drivers.push({
            driverId: driver.driverId,
            name: driver.firstName + ' ' + driver.lastName,
            phone: null,
            email: null,
            isHomeBase: false,
            packageId: null,
            rsvpId: null,
            pickupTime: null,
            shiftStart: driver.shiftStart,
            shiftEnd: driver.shiftEnd,
            location: null,
            photo: null,
            services: driver.services
          })
        } else {
          let start = driver.shiftStart.unix()
          let end = driver.shiftEnd.unix()
          if (self.rsvp !== null) {
            if (drivers[index].shiftStart === null &&
                drivers[index].shiftEnd === null) {
              let puTime = pickupTime.unix()
              if (puTime >= start && puTime <= end) {
                drivers[index].shiftStart = driver.shiftStart
                drivers[index].shiftEnd = driver.shiftEnd
              }
            }
          }

          if (gap !== null) {
            let gapStart = gap.start.unix()

            if (gapStart >= start && gapStart <= end) {
              drivers[index].shiftStart = driver.shiftStart
              drivers[index].shiftEnd = driver.shiftEnd
            }
          }
        }
      }

      // dropoff drivers
      for (let i = 0; i < sector.driverDropoff.length; i++) {
        let driver = sector.driverDropoff[i]
        if (driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue
        }
        let index = self.findDriverIndexInList(driver.driverId, drivers)

        let dropoffTime = driver.dropoffTime
        if (index === null) {
          let insertDriver = false
          if (self.rsvp !== null) {
            let puTime = pickupTime.unix()
            if (Math.abs(puTime - dropoffTime) <= 3600) { // clearing time within the hour
              insertDriver = true
            }
          }

          if (gap !== null) {
            let gapStart = gap.start.unix()
            let gapEnd = gap.end.unix()

            if (dropoffTime >= gapStart && dropoffTime <= gapEnd) {
              insertDriver = true
            }
          }

          if (insertDriver) {
            drivers.push({
              driverId: driver.driverId,
              name: driver.firstName + ' ' + driver.lastName,
              phone: null,
              email: null,
              isHomeBase: false,
              packageId: driver.packageID,
              rsvpId: driver.rsvpId,
              pickupTime: moment.unix(driver.pickupTime),
              dropoffTime: moment.unix(driver.dropoffTime),
              shiftStart: null,
              shiftEnd: null,
              location: null,
              photo: null,
              services: driver.services
            })
          }
        } else {
          if (self.rsvp !== null) {
            let puTime = pickupTime.unix()
            if (Math.abs(puTime - dropoffTime) <= 3600) { // clearing time within the hour
              drivers[index].packageId = driver.packageID
              drivers[index].rsvpId = driver.rsvpId
              drivers[index].pickupTime = moment.unix(driver.pickupTime)
              drivers[index]['dropoffTime'] = moment.unix(driver.dropoffTime)
            }
          }

          if (gap !== null) {
            let gapStart = gap.start.unix()
            let gapEnd = gap.end.unix()

            if (dropoffTime >= gapStart && dropoffTime <= gapEnd) {
              drivers[index].packageId = driver.packageID
              drivers[index].rsvpId = driver.rsvpId
              drivers[index].pickupTime = moment.unix(driver.pickupTime)
              drivers[index]['dropoffTime'] = moment.unix(driver.dropoffTime)
            }
          }
        }
      }

      let ids = []
      for (let i = 0; i < drivers.length; i++) {
        ids.push(drivers[i].driverId)
      }
      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: ids
      }, r => {
        if (r.error) {
          // show error
        } else {
          for (let i = 0; i < r.list.length; i++) {
            let driver = r.list[i]
            let index = self.findDriverIndexInList(driver.ID, drivers)
            if (index === null) {
              continue
            }

            drivers[index].phone = '' + driver.phone
            drivers[index].email = driver.email
            drivers[index].photo = driver.avatarUrl
            drivers[index]['vehicle'] = driver.vehicle
            drivers[index]['firstName'] = driver.firstName
            drivers[index]['lastName'] = driver.lastName
            if (driver.tracks !== null) {
              let heading = parseInt(driver.tracks.heading)

              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvp !== null) {
                  let location = null
                  if (!self.rsvp.isPackage) {
                    location = self.rsvp.pickupLocation
                  } else {
                    location = self.rsvp.stops[0]
                  }
                  heading = self.computeHeading(driver.tracks, location)
                } else {
                  heading = Math.floor(Math.random() * Math.floor(360))
                }
              }
              drivers[index].location = {
                lat: driver.tracks.lat,
                lng: driver.tracks.lng,
                heading: heading,
                // pin: self.renderDriverPin(heading),
                showInfo: false
              }
            }
          }
        }

        self.drivers.sector = drivers
        self.noDrivers = false

        if (drivers.length <= 0) {
          self.noDrivers = true
          return
        }

        self.addDriversToMap()
        // self.centerDrivers()
      })
    },
    centerDrivers () {
      let self = this
      let points = []

      for (let i = 0; i < self.drivers.sector.length; i++) {
        let driver = self.drivers.sector[i]
        if (driver.location === null) {
          continue
        }
        points.push({
          lat: driver.location.lat,
          lng: driver.location.lng
        })
      }

      if (points.length <= 0) {
        return
      }
      self.setBounds(points)
    },
    renderDriverPin (heading) {
      return {
        url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/car-sprite.png',
        origin: new google.maps.Point(heading * 60, 0), // eslint-disable-line no-undef
        anchor: {
          x: 30,
          y: 30
        },
        size: {
          width: 60,
          height: 60
        }
      }
    },
    computeHeading (orig, dest) {
      let y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat)
      let x = Math.cos(orig.lat) * Math.sin(dest.lat) -
              Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng)

      let brng = Math.atan2(y, x) * 180 / Math.PI
      return Math.round(360 - ((brng + 360) % 360))
    },
    toggleDriverInfo (index) { this.drivers.sector[index].location.showInfo = !this.drivers.sector[index].location.showInfo },
    closeDriverInfo (index) { this.drivers.sector[index].location.showInfo = false },
    callDriver (driver) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    toggleStopsInfo(index) {
      this.stopsInfo[index] = !this.stopsInfo[index]
    },
    placePolygon (value) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        self.hereMaps.map.removeObject(object)
      }

      if (value) {
        let group = new window.H.map.Group()
        let groupObject = []

        value.forEach(val => {
          let reader = new window.H.data.kml.Reader(val.kmlFile)
          reader.parse()

          reader.addEventListener('statechange', async function () {
            if (this.getState() === window.H.data.AbstractReader.State.READY) {
              var objects = reader.getParsedObjects()
              if (objects[0] instanceof H.map.Group) {
                objects = objects[0]
              }

              objects.forEach((obj, i, group) => {
                if (obj instanceof H.map.Polygon && !obj.id) {
                  obj.setStyle({
                    strokeColor: val.overlayColor,
                    fillColor: self.hexaToDeci(val.overlayColor),
                    lineWidth: 2
                  })
                  obj.id = val.id
                  groupObject.push(obj)
                }
              }, true, this)
            }
          })

          if (groupObject.length) {
            group.addObjects(groupObject)
            group.id = 'groupBound'
            self.hereMaps.map.addObject(kmlGroup)
            self.hereMaps.map.getViewModel().setLookAtData({
              bounds: kmlGroup.getBoundingBox()
            })
          }

          let layer = reader.getLayer()
          self.hereMaps.map.addLayer(layer)
        })
        // self.setCenter()
      }
    },
    hexaToDeci (val) {
      let hex = val.replace('#', '').match(/.{1,2}/g)
      return 'rgba(' + parseInt(hex[0], 16) + ',' + parseInt(hex[1], 16) + ',' +  parseInt(hex[2], 16) + ', .4)'
    },
    addMarkerToMap (data, type) {
      let self = this

      let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
        '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
        'stroke-width="{STROKE_WIDTH}" /></svg>'
      marker = marker.replace('{D}', mapPins[type].path)
        .replace('{FILL}', mapPins[type].fillColor)
        .replace('{STROKE}', mapPins[type].strokeColor)
        .replace('{STROKE_WIDTH}', mapPins[type].strokeWeight)

      let icon = new window.H.map.DomIcon(marker)
      let coords = {lat: data.lat, lng: data.lng}
      let pin = new window.H.map.DomMarker(coords, {icon: icon})
      pin.id = 'marker'
      pin.lat = coords.lat
      pin.lng = coords.lng
      self.hereMaps.map.addObject(pin)
    },
    addInfowWindow (data, type) {
      let self = this
      let content = `<div class="here-info-window-content coverage rsvp">
        <label>PICKUP TIME:</label>
        <span class="value">{PICKUPTIME}</span>
      </div>`
      if (type === 'pickup') {
        content = content.replace('{PICKUPTIME}', moment(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'))
      } else if (type === 'dropoff') {
        content = `<div class="here-info-window-content coverage rsvp">{DROPOFFTIME}{DISTANCE}</div>`
        if (data.dropoffTime) {
          let dropoffTime = moment(data.dropoffTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mmA')
          content = content.replace('{DROPOFFTIME}', `<div class="label-value">
            <label>EST DROPOFF TIME</label>
            <span class="value"> ${dropoffTime} </span>
          </div>`)
        } else {
          content = content.replace('{DROPOFFTIME}', '')
        }

        if (data.distance) {
          let distance = Math.round((data.distance * .001) * 0.6214) + ' miles'
          content = content.replace('{DISTANCE}', `<div class="label-value">
            <label>TRAVEL DISTANCE</label>
            <span class="value"> ${distance} </span>
          </div>`)
        } else {
          content = content.replace('{DISTANCE}', '')
        }
      }

      let bubble = new window.H.ui.InfoBubble(data, {content: content})
      bubble.id = type + data.id
      self.hereMaps.ui.addBubble(bubble)
      bubble.addEventListener('tap', function (evt) {
        bubble.open()
      }, false)
    },
    addPathToMap (origin, destination) {
      let self = this
      let router = self.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${origin.lat},${origin.lng}`,
        destination: `${destination.lat},${destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }

      router.calculateRoute(routeRequestParams,
        success => {
          if (success.routes.length) {
            let route = success.routes[0].sections[0]
            let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
            let polyline = new window.H.map.Polyline(linestring, {
              style: {
                lineWidth: 4,
                strokeColor: 'rgba(25, 25, 25, 0.7)'
              }
            });
            polyline.id = 'route'
            this.hereMaps.map.addObject(polyline)
            this.hereMaps.map.getViewModel().setLookAtData({
              bounds: polyline.getBoundingBox()
            })
  
            if (self.isRsvp) {
              self.addInfowWindow({
                id: self.rsvp.ID,
                lat: destination.lat,
                lng: destination.lng,
                dropoffTime: moment(self.rsvp.pickupDate, 'YYYY-MM-DD HH:mm').add(route.travelSummary.duration, 'seconds').format('YYYY-MM-DD HH:mm'),
                distance: route.travelSummary.length
              }, 'dropoff')
            }
          }

          // this.setCenter()
        },
        error => {
          console.log('ROUTE ERROR:', error)
        }
      )
    },
    addPkgPathToMap () {
      let self = this

      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
      self.rsvp.stops.forEach((coords, index) => {
        if (index == 0) {
          url += `&origin=${coords.lat},${coords.lng}`
        } else if (index == self.rsvp.stops.length - 1) {
          url += `&destination=${coords.lat},${coords.lng}`
        } else {
          url += `&via=${coords.lat},${coords.lng}`
        }
      })
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTE ERROR:', err)
          return
        }
        
        if (!body.routes.length) return
        let routes = body.routes[0].sections
        routes.forEach((route, index) => {
          let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
          let polyline = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 4,
              strokeColor: 'rgba(25, 25, 25, 0.7)'
            }
          });
          polyline.id = `route${index}`
          this.hereMaps.map.addObject(polyline)
        })
      })
    },
    addDriversToMap () {
      let self = this

      self.drivers.sector.forEach(driver => {
        if (driver.location && driver.location.lat && driver.location.lng) {
          let marker = `<div class="rotator">
            <div class='here-marker car-icon' style="transform: rotate({HEADING})"></div>
          </div>`
          let destination = self.rsvp.isPackage ? self.rsvp.stops[0] : self.rsvp.pickupLocation
          let heading = self.computeHeading(driver.location, destination)
          marker = marker.replace('{HEADING}', heading + 'deg')

          let coords = {lat: driver.location.lat, lng: driver.location.lng}
          let infoWindow = document.getElementById('HCar')
          let carBubble = new window.H.ui.InfoBubble(coords, {content: infoWindow})
          carBubble.id = 'car-info' + driver.driverId
          self.hereMaps.ui.addBubble(carBubble)
          carBubble.close()

          let icon = new window.H.map.DomIcon(marker, {
            onAttach: (cloned, icon2, marker) => {
              cloned.addEventListener('click', evt => {
                if (self.$refs.HCar.update(driver)) {
                  self.$refs.HCar.update(driver)
                }
                carBubble.open()
              })
            },
            onDetach: (cloned, icon, marker) => {
              cloned.removeEventListener('click', evt => {})
            }
          })


          let pin = new window.H.map.DomMarker(coords, {icon: icon})
          pin.id = 'nearbyDrivers' + driver.driverId
          pin.lat = coords.lat
          pin.lng = coords.lng
          self.hereMaps.map.addObject(pin)
        }
      })
    },
    addKmlToMap (id) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        self.hereMaps.map.removeObject(object)
      }
      self.hereMaps.ui.getBubbles().forEach(bub => {
        bub.close()
      })
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles())
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects())

      let index = self.sectorItems.findIndex(x => x.ID === id)
      if (!id || index === -1) { return }
      let sectorData = self.sectorItems[index]
      let kmlGroup = new window.H.map.Group()
      let reader = new window.H.data.kml.Reader(sectorData.kmlFile)
      reader.parse()

      reader.addEventListener('statechange', async function () {
        if (this.getState() === window.H.data.AbstractReader.State.READY) {
          let objects = reader.getParsedObjects()
          if (objects[0] instanceof H.map.Group) {
            objects = objects[0]
          }

          objects.forEach((obj, i, group) => {
            if (obj instanceof H.map.Polygon && !obj.id) {
              obj.setStyle({
                strokeColor: sectorData.overlayColor,
                fillColor: self.hexaToDeci(sectorData.overlayColor),
                lineWidth: 2
              })
              obj.id = sectorData.ID
              kmlGroup.addObject(obj)

              self.hereMaps.map.getViewModel().setLookAtData({
                bounds: obj.getBoundingBox()
              })
            }
          }, true, this)
        }
      })

      self.hereMaps.map.addObject(kmlGroup)
      // let layer = reader.getLayer()
      // self.hereMaps.map.addLayer(layer)
    },
    addKmlToMap2 (kmls) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        if (kmls.indexOf(object.id) == -1) {
          self.hereMaps.map.removeObject(object)
        }
      }
      if (!kmls.length) return

      kmls.forEach(kml => {
        if (self.hereMaps.map.getObjects().findIndex(x => x.id == kml) > -1) return
        let index = self.sectorItems.findIndex(x => x.ID === kml)
        let sectorData = self.sectorItems[index]
        let kmlGroup = new window.H.map.Group()
        let reader = new window.H.data.kml.Reader(sectorData.kmlFile)
        reader.parse()

        reader.addEventListener('statechange', async function () {
          if (this.getState() === window.H.data.AbstractReader.State.READY) {
            let objects = reader.getParsedObjects()
            if (objects[0] instanceof H.map.Group) {
              objects = objects[0]
            }

            objects.forEach((obj, i, group) => {
              if (obj instanceof H.map.Polygon && !obj.id) {
                obj.setStyle({
                  strokeColor: sectorData.overlayColor,
                  fillColor: self.hexaToDeci(sectorData.overlayColor),
                  lineWidth: 2
                })
                kmlGroup.addObject(obj)

                self.hereMaps.map.getViewModel().setLookAtData({
                  bounds: obj.getBoundingBox()
                })
              }
            }, true, this)
            kmlGroup.id = sectorData.ID
          }
        })
        self.hereMaps.map.addObject(kmlGroup)
      })
    },
  },
  watch: {
    sectorItems (value) {
      // this.resetCenter()
      // this.placePolygon(value)
    },
    coverageGap (value) {
      let self = this
      if (value === null) {
        self.infoWindows.pickup = false
        self.infoWindows.dropoff = false
        self.drivers.sector = []
        self.noDrivers = false
        self.drivers.nearby = []
        self.resetCenter()
        return
      }
      self.findDrivers()
    },
    rsvp (value) {
      let self = this

      self.hereMaps.ui.getBubbles().forEach(bub => {
        bub.close()
      })
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles())
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects())

      self.isRsvp = true
      if (value === null) {
        self.isRsvp = false
        // RESET MAP TO CENTER OR SOMETHING
        return
      }

      if (value.isPackage) {
        value.stops.forEach(stop => {
          self.addMarkerToMap(stop, stop.isPickup ? 'pickup' : 'dropoff')
        })
        self.addPkgPathToMap()
      } else {
        let pickupCoords = {
          lat: value.pickupLocation.lat,
          lng: value.pickupLocation.lng
        }
        self.addMarkerToMap(pickupCoords, 'pickup')
        self.addInfowWindow({
          id: value.ID,
          pickupDate: value.pickupDate,
          lat: pickupCoords.lat,
          lng: pickupCoords.lng
        }, 'pickup')

        let dropoffCoords = {
          lat: value.dropoffLocation.lat,
          lng: value.dropoffLocation.lng
        }
        self.addMarkerToMap(dropoffCoords, 'dropoff')
        self.addPathToMap(value.pickupLocation, value.dropoffLocation)

      }

      self.findDrivers()
    },
    kmlInMap (value) {
      // this.addKmlToMap(value)
    },
    kmlsInMap (value) {
      this.addKmlToMap2(value)
    },
    _triggerWatch (value) {
      if (value) {
        this.$store.commit('coverage/setTriggerWatch', false)
        let trigger = this.$store.state.coverage.trigger

        if (trigger.action === 'sendToDriver') {
          this.sendToDriver(trigger.data)
        }
        if (trigger.action === 'assignToDriver') {
          this.assignToDriver(trigger.data)
        }
      }
    }
  },
  mounted () {
    let self = this
    let mapContainer = document.getElementById('mapHere')
    self.hereMaps.platform = new window.H.service.Platform({
      apikey: CONFIG.hereApi.key
    })

    let defaultLayers = self.hereMaps.platform.createDefaultLayers()
    self.hereMaps.map = new window.H.Map(mapContainer,
      defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      }
    )

    /* eslint-disable no-unused-vars */
    let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)

    window.addEventListener('resize', () => self.hereMaps.map.getViewPort().resize())
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.coverage-map{ display: none; }
.coverage-map, .map-here{
  width: 100%;
  height: 100%;
}

.driver-info {
  font-family: 'Open Sans', sans-serif;
  padding: 5px 0 0 5px;
  & .header {
    position: relative;
    min-height: 50px;
    padding-left: 60px;
    padding-top: 0px;
  }

  & .photo {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    border: 1px solid rgba(0,0,0,0.3);
  }

  & .name {
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
  }

  & .email {
    font-size: 12px;
    line-height: 12px;
    margin-top: 5px;
  }

  & .vehicle {
    margin-top: 10px;
    position: relative;
    min-height: 50px;
    padding-left: 60px;
    padding-top: 10px;
  }

  & .shift-info {
    font-size: 14px;
    line-height: 14px;
    margin-top: 15px;
    text-align: center;

    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & i { color: #26D97A; }

    & .shift-value {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .rsvp-info {
    font-size: 14px;
    line-height: 16px;
    margin-top: 15px;
    text-align: center;

    & .highlight, a {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .controls {
    margin-top: 15px;

    & .padding-R { padding-right: 3px; }
    & .padding-L { padding-left: 3px; }

    & .button {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  & .is-home {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: #26D97A;
    text-align: center;
    line-height: 30px;
    color: #fff;
  }
}

.no-drivers {
  position: absolute;
  top: 12px;
  right: -400px;
  background-color: #fff;
  text-align: center;
  width: 300px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.35);
  border-radius: 3px;
  transition: all 250ms;
  font-size: 14px;
  padding: 15px;

  &.show { right: 15px; }

  & .message {
    margin-top: 10px;
    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & .highlight {
      font-weight: 700;
    }
  }
}
.untracked-drivers {
  position: absolute;
  top: 12px;
  right: -400px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0,0,0,0.35);
  border-radius: 3px;
  width: 350px;
  transition: all 250ms;
  max-height: 90%;
  overflow-y: auto;
  overflow-x: hidden;

  &.show { right: 15px; }

  & .title {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    padding: 10px 0 7px;
    color: #555; // #0D79F2;
  }

  & .driver {
    padding: 10px 10px 5px;
    border-top: 1px solid rgba(0,0,0,0.2);
    position: relative;
  }

  & .is-home {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: #26D97A;
    text-align: center;
    line-height: 30px;
    color: #fff;
  }

  & .header {
    position: relative;
    min-height: 50px;
    padding-left: 60px;

    & .photo {
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      border: 1px solid rgba(0,0,0,0.3);
    }

    & .name {
      font-size: 14px;
      line-height: 14px;
      font-weight: 700;
    }

    & .email {
      font-size: 12px;
      line-height: 12px;
      margin-top: 5px;
    }
  }

  & .vehicle {
    position: relative;
    padding-left: 60px;
    padding-top: 8px;
    margin-top: 5px;
    height: 50px;

    & .photo {
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      border: 1px solid rgba(0,0,0,0.3);
    }

    & .name {
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
    }

    & .plate-number {
      font-size: 14px;
      line-height: 14px;
      margin-top: 5px;
    }
  }

  & .shift-info {
    font-size: 14px;
    line-height: 14px;
    margin-top: 15px;
    text-align: center;

    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & i { color: #26D97A; }

    & .shift-value {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .rsvp-info {
    font-size: 14px;
    line-height: 16px;
    margin-top: 15px;
    text-align: center;

    & .highlight, a {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .controls {
    margin-top: 15px;

    & .padding-R { padding-right: 3px; }
    & .padding-L { padding-left: 3px; }

    & .button {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.point-info {
  padding: 0 0 5px 5px;
  background-color: #fff;
  font-family: 'Open Sans', sans-serif;

  & label {
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    color: #0D79F2;
  }

  & .value {
    font-size: 14px;
    font-weight: 700;
  }

  & .label-value:not(:first-child) { margin-top: 10px; }
}

.submission-modal {
  display: table;
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 12;
  transition: all 250ms;

  &.show { top: 0; opacity: 1; }

  & .modal-container {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  & .modal-content {
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    width: 350px;
    margin: 0 auto;
    padding: 20px 15px;
    border-radius: 5px;
  }

  & .loader .message {
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    margin-top: 10px;
  }

  & .success-icon { color: #26D97A; }
  & .error-icon { color: #F25E0D; }
}
</style>



// WEBPACK FOOTER //
// src/components/Coverage/Map2.vue